import { useEffect, useState } from 'react';
import { useWindowSize } from '@yme/hooks/index';
import { useIsMount } from '@yme/hooks/useIsMount';
import { getButtonsParameters } from './helpers';
export function useButtonsGroup({ holderRef, childElements, extraDeps = false, getter: inputGetter, }) {
    const [isArrangedByLine, setIsArrangedByLine] = useState(true);
    const { width } = useWindowSize();
    const isMount = useIsMount();
    const { isArrangedByLineResult, count } = getButtonsParameters({
        holderRef,
        childElements,
        getter: inputGetter,
    });
    useEffect(() => {
        if (width && !isMount && isArrangedByLineResult !== null && count > 0) {
            setIsArrangedByLine(isArrangedByLineResult);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isArrangedByLineResult, width, count, isMount, extraDeps]);
    return {
        isArrangedByLine,
        count,
        getter: inputGetter,
    };
}
